import {
  TBulkDiscount,
  TBulkDiscountTableProps,
} from '../../../../../utils/types';
import {
  DeleteNode,
  EditNode,
  VisibilityNode,
  useRowSelect,
} from '../../../../../components/Table/actionNodes';
import {
  Column,
  statusPillVariant,
} from '../../../../../types';
import { useState } from 'react';
import { useAuthHelper } from '../../../../../utils/functions/authentication';
import dayjs from 'dayjs';
import { BULK_DISCOUNT_STATUS_OPTIONS } from '../../../../../utils/constants/discounts';
import StatusPills from '../../../../../components/StatusPills';

export const useTableHelper = (
  currentPageListDataIds: number[]
) => {
  const [deleteDiscountData, setDeleteDiscountData] =
    useState<TBulkDiscount>();
  const { checkPageAccess } = useAuthHelper();
  const {
    seletedIds,
    setSeletedIds,
    checkbox,
    selectAllCheckBox,
  } = useRowSelect();
  const hasEditAccess = checkPageAccess(
    'BULK_DISCOUNT_EDIT'
  );

  const getStatus = (details: TBulkDiscount) => {
    const currDate = new Date();
    if (dayjs(details.startDate).isAfter(currDate)) {
      return 'UPCOMING';
    }
    if (
      dayjs(details.endDate).isSame(currDate) ||
      dayjs(details.endDate).isAfter(currDate)
    ) {
      return 'ACTIVE';
    }
    return 'PAST';
  };

  const actionNode = (tableRowData: TBulkDiscount) => {
    const editUrl = `/bulk-discount/edit-bulk?id=${tableRowData.id}`;
    const viewUrl = `/bulk-discount/view-bulk?id=${tableRowData.id}`;
    return (
      <div>
        <VisibilityNode url={viewUrl} />
        {hasEditAccess &&
          getStatus(tableRowData) === 'UPCOMING' && (
            <EditNode url={editUrl} />
          )}
        {hasEditAccess &&
          getStatus(tableRowData) !== 'PAST' && (
            <DeleteNode
              onClick={() =>
                setDeleteDiscountData(tableRowData)
              }
            />
          )}
      </div>
    );
  };

  const columns: Column<
    TBulkDiscountTableProps,
    keyof TBulkDiscountTableProps
  >[] = [
    {
      key: 'selectRow',
      label: selectAllCheckBox(currentPageListDataIds),
      cellModifier: (data: TBulkDiscount) =>
        checkbox(data.id),
    },
    {
      key: 'productName',
      label: 'Product',
    },
    {
      key: 'enterpriseName',
      label: 'Seller name',
    },
    {
      key: 'plantName',
      label: 'Plant',
    },
    {
      key: 'startDateStr',
      label: 'Start Date',
    },
    { key: 'endDateStr', label: 'End Date' },
    {
      key: 'status',
      label: 'Status',
      cellModifier: (data: TBulkDiscount) => {
        const status = getStatus(data);
        let pillVariant: statusPillVariant;
        switch (status) {
          case 'ACTIVE':
            pillVariant = statusPillVariant.GREEN;
            break;

          case 'UPCOMING':
            pillVariant = statusPillVariant.YELLOW;
            break;

          case 'PAST':
            pillVariant = statusPillVariant.RED;
            break;

          default:
            pillVariant = statusPillVariant.GREEN;
            break;
        }
        return (
          <StatusPills
            variant={pillVariant}
            className="mr-5">
            {
              BULK_DISCOUNT_STATUS_OPTIONS.find(
                (option) => status == option.value
              )?.label as string
            }
          </StatusPills>
        );
      },
    },
    {
      key: 'action',
      label: 'Action',
      cellModifier: (data: TBulkDiscount) =>
        actionNode(data),
    },
  ];

  return {
    columns,
    deleteDiscountData,
    setDeleteDiscountData,
    hasEditAccess,
    seletedIds,
    setSeletedIds,
  };
};
